



































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import moment from 'moment';

import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import SlipLineNoField from '@/components/atom/input/SlipLineNoField.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import {loginModule} from '@/store/authentication/login';

import {
  入庫入力型,
  採用区分型,
} from '@/type/stock/receive/unfixed';
import {マスタ選択区分型} from '@/type/wholesale/types';

import ToggleButtonField from '@/views/stock/StockToggleButtonField.vue';
import StockReceiveWholesaleSelector from '@/views/stock/receive/StockReceiveWholesaleSelector.vue';
import 入庫候補入力チェッカー from '@/type/stock/receive/入庫候補入力チェッカー';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
    Datepicker,
    SlipLineNoField,
    ToggleButtonField,
    AmountField,
    StockReceiveWholesaleSelector,
  },
})
export default class UnfixedStockDataRow extends Vue {
  // props
  @Prop()
  value!: 入庫入力型;
  @Prop()
  rowIndex!: number;

  // events
  @Emit()
  clickDeleteButton(): object {
    return {rowIndex: this.rowIndex};
  }

  // computed
  get 編集不可(): boolean {
    return this.value.入力方法 === '納品データ';
  }

  get 単価編集不可(): boolean {
    if (loginModule.渓仁会仕様である) return false;
    else if (this.value.入力方法 === '納品データ') return true;
    return false;
  }

  get 確定不可(): boolean {
    return this.value.入庫確定不可区分 === '確定不可';
  }

  get 確定不可Style(): object {
    return {確定不可: this.確定不可};
  }

  get 確定可能(): boolean {
    return !this.確定不可;
  }

  get 削除可能(): boolean {
    if (this.value.入力方法 === '納品データ') return this.確定不可;
    return true;
  }

  get マスタ選択区分(): マスタ選択区分型 {
    return (this.value.採用区分 === 採用区分型.採用品) ? マスタ選択区分型.採用品 : マスタ選択区分型.指定なし;
  }

  get 入庫日付Style(): object {
    return {alert: this.入力エラーが存在する('入庫日付')};
  }

  get 入力単価Style(): object {
    return {alert: this.入力エラーが存在する('入力単価')};
  }

  get 入庫数Style(): object {
    return {alert: this.入力エラーが存在する('入庫数')};
  }

  get 有効期限Style(): object {
    return {alert: this.入力エラーが存在する('有効期限')};
  }

  get ロット番号Style(): object {
    return {'input-error': this.入力エラーが存在する('ロット番号')};
  }

  get 伝票番号Style(): object {
    return {'input-error': this.入力エラーが存在する('伝票番号')};
  }

  get 伝票行番号Style(): object {
    return {'input-error': this.入力エラーが存在する('伝票行番号')};
  }

  // methods
  入力エラーが存在する(項目名: string): boolean {
    const checker = new 入庫候補入力チェッカー();
    checker.validate(this.value);
    return checker.hasError(項目名);
  }
}
